module.exports = __webpack_public_path__ + "media/images/icons/facebookIcon-9393ce9fbf54e37e1b20568d147f44e9.svg";